import AbstractModule from './AbstractModule';

export default class extends AbstractModule {
    /**
     * Constructeur.
     *
     * @return {void}
     */
    constructor(options) {
        super(options);

        // options en paramètres
        this.COLUMNS       = options.columns || 2;
        this.SLOTS         = options.slots || 3;
        this.SLOTS_MAX     = this.SLOTS * this.COLUMNS;
        this.GALLERY_IDENT = options['gallery-id'];

        // si mobile, 1 colone uniquement
        if (window.matchMedia('(max-width: 699px)').matches) {
            this.COLUMNS = 1;
            this.SLOTS_MAX = this.SLOTS * this.COLUMNS;
        }

        // initialisation des variables
        this.currentRangeId   = 0;
        this.currentFullImage = 0;
        this.$dom             = {};
        this.$domFullGallery  = {};
        this.datas            = undefined;

        // initialisation
        this.init();
    }

    /**
     * Initialisation.
     *
     * @return {void}
     */
    init() {
        // dom elements
        // this.$dom.navigation = this.$el.find('.js-gallery-navigation');
        this.$dom.wrap    = this.$el.find('.js-gallery-wrap');
        this.$dom.image   = this.$el.find('.js-gallery-image');
        this.$dom.link    = this.$el.find('.js-gallery-link');
        this.$dom.viewall = this.$el.find('.js-gallery-viewall');

        // activer les éléments du dom en fonction du
        // nombre de colonnes qui doivent être affichées
        for (let i = 0; i < this.COLUMNS; i += 1) {
            this.$dom.wrap.eq(i).removeClass('u-hidden');
        }

        // initialisation des données
        this.initDatas();

        // initialiser les événements
        this.initEvents();

        // afficher les données
        this.updateDatas();
    }

    /**
     * Initialisation des événements.
     *
     * @return {void}
     */
    initEvents() {
        // this.$el.on('click.Gallery', '.js-gallery-next', event => {
        //     event.preventDefault();
        //     this.nextRange();
        // });

        // this.$el.on('click.Gallery', '.js-gallery-prev', event => {
        //     event.preventDefault();
        //     this.prevRange();
        // });

        this.$el.on('click.Gallery', '.js-gallery-link', event => {
            event.preventDefault();
            this.onOpenFullGallery(event);
        });

        this.$el.on('click.Gallery', '.js-gallery-viewall', event => {
            event.preventDefault();
            this.onOpenFullGallery(event);
        });
    }

    /**
     * Initialisation des données.
     *
     * @return {void}
     */
    initDatas() {
        let ident = this.GALLERY_IDENT;

        if (ident) {
            this.datas = window.images[ident];
        }

        // chargement des images
        this.preloadAllImages();

        // affichage du bouton viewall si nécessaire
        if (this.SLOTS_MAX < this.datas.length) {
            const nb = this.datas.length - this.SLOTS_MAX;
            if (nb === 1) {
                this.$el.find('.js-gallery-one').removeClass('u-hidden');
            } else {
                this.$el.find('.js-gallery-multiple').removeClass('u-hidden');
                this.$el.find('.js-gallery-count').text(nb);
            }

            this.$dom.viewall.removeClass('u-hidden');
            this.$dom.viewall.attr('data-id', this.SLOTS_MAX);
        }

        // désactiver les fléches si le nombre d'images
        // est inférieur au nombre de slots disponibles
        // if (this.SLOTS_MAX >= this.datas.length) {
        //     this.$dom.navigation.addClass('u-hidden');
        // }
    }

    /**
     * Préchargement de toutes les images.
     *
     * @return {void}
     */
    preloadAllImages() {
        for (let i = 0; i < this.datas.length; i += 1) {
            const image = new Image();
            image.src   = this.datas[i].src;
        }
    }

    /**
     * Mettre à jour le range devant être affiché.
     * (affichage des éléments suivants)
     *
     * @return {void}
     */
    // nextRange() {
    //     // on execute la méthode uniquement s'il y a
    //     // plus d'images que de slots disponibles
    //     if (this.datas.length > this.SLOTS_MAX) {
    //         if ((this.currentRangeId + this.SLOTS_MAX) < this.datas.length) {
    //             this.currentRangeId += this.SLOTS_MAX;
    //         } else {
    //             this.currentRangeId = this.SLOTS_MAX - (this.datas.length % this.currentRangeId);
    //         }
    //
    //         // mettre à jour les données
    //         this.updateDatas();
    //     }
    // }

    /**
     * Mettre à jour le range devant être affiché.
     * (affichage des éléments précédents)
     *
     * @return {void}
     */
    // prevRange() {
    //     // on execute la méthode uniquement s'il y a
    //     // plus d'images que de slots disponibles
    //     if (this.datas.length > this.SLOTS_MAX) {
    //         if (this.currentRangeId - this.SLOTS_MAX >= 0) {
    //             this.currentRangeId -= this.SLOTS_MAX;
    //         } else {
    //             this.currentRangeId = this.datas.length - (this.SLOTS_MAX - this.currentRangeId);
    //         }
    //
    //         // mettre à jour les données
    //         this.updateDatas();
    //     }
    // }

    /**
     * Création d'un objet contenant l'ensemble des
     * données à afficher en fonction du range courant.
     *
     * @return {object}  objet contenant l'ensemble des données
     */
    getDatas() {
        const datas = [];

        // on récupére toute les images après le range
        let max = this.currentRangeId + this.SLOTS_MAX;
        for (let i = this.currentRangeId; i < max; i += 1) {
            if (this.datas[i] !== undefined) {
                datas.push(this.datas[i]);
            } else {
                break;
            }
        }

        // si le tableau ne contient pas le même nombre
        // d'éléments que `this.SLOTS_MAX` il faut
        // prendre les éléments en début du tableau
        if (this.SLOTS_MAX <= this.datas.length && datas.length !== this.SLOTS_MAX) {
            max = this.SLOTS_MAX - datas.length;
            for (let i = 0; i < max; i += 1) {
                datas.push(this.datas[i]);
            }
        }

        return datas;
    }

    /**
     * Ajouter un élément avec son contenu.
     *
     * @return {void}
     */
    addElement(id, data) {
        this.$dom.link.eq(id).attr('href', data.src);
        this.$dom.link.eq(id).attr('data-id', data.id);
        this.$dom.link.eq(id).attr('data-caption', data.caption);
        this.$dom.image.eq(id).css('background-image', `url('/${data.src}')`);
    }

    /**
     * Mettre a jour l'affichage des données.
     *
     * @return {void}
     */
    updateDatas() {
        // ne pas afficher les slots
        this.$el.removeClass('is-show-images');

        // mettre à jour les données
        setTimeout(() => {
            // récupération des données
            const datas = this.getDatas();

            // ajouter les éléments au dom
            for (let i = 0; i < datas.length; i += 1) {
                this.addElement(i, datas[i]);
            }

            // affichage des slots
            this.$el.addClass('is-show-images');
        }, 900);
    }

    /**
     * Événement pour gérer l'ouverture de
     * la gallery en plein écran.
     *
     * @return {void}
     */
    onOpenFullGallery(event) {
        const id              = $(event.currentTarget).data('id') || 0;
        const image           = (this.datas[id] === undefined) ? this.datas[0] : this.datas[id];
        this.currentFullImage = id;

        // création de la galerie en plein écran
        this.createDomFullGallery(image);

        // mise à jour de la navgiation
        this.updateFullGalleryNavigation();

        // ajouter la classe d'ouverture de la gallerie
        setTimeout(() => {
            this.$body.addClass('has-gallery-opened');
        }, 300);
    }

    /**
     * Événement pour gérer la fermeture de
     * la gallery en plein écran.
     *
     * @return {void}
     */
    onCloseFullGallery(event) {
        this.$body.removeClass('has-gallery-opened');

        // suppression de l'évenement close
        // une fois la galerie fermée
        this.$document.off('.Gallery');

        // suppression des références DOM
        this.$domFullGallery = {};

        // supprimer le DOM lié à l'affichage
        // de la galerie en plein écran
        setTimeout(()=>{
            this.$document.find('.js-galleryfull-popup').remove();
        },1000);
    }

    /**
     * Événement pour passer à la photo précédente.
     *
     * @param {event}  événement pour clique
     * @return {void}
     */
    onPrevFullGallery(event) {
        event.preventDefault();

        if (this.currentFullImage === 0) {
            this.currentFullImage = this.datas.length - 1;
        } else {
            this.currentFullImage -= 1;
        }

        this.updateImageFullGallery('left');
    }

    /**
     * Événement pour passer à la photo suivante.
     *
     * @param {event}  événement pour clique
     * @return {void}
     */
    onNextFullGallery(event) {
        event.preventDefault();

        if (this.currentFullImage === (this.datas.length - 1)) {
            this.currentFullImage = 0;
        } else {
            this.currentFullImage += 1;
        }

        this.updateImageFullGallery('right');
    }

    /**
     * Permet d'initialiser les événements DOM
     * de la FullGallery.
     *
     */
    initDomFullGallery() {
        this.$domFullGallery.popup      = this.$document.find('.js-galleryfull-popup');
        this.$domFullGallery.image      = this.$document.find('.js-galleryfull-image');
        this.$domFullGallery.figcaption = this.$document.find('.js-galleryfull-figcaption');
        this.$domFullGallery.title      = this.$document.find('.js-galleryfull-title');
        this.$domFullGallery.caption    = this.$document.find('.js-galleryfull-caption');
        this.$domFullGallery.download   = this.$document.find('.js-galleryfull-download');
        this.$domFullGallery.prev       = this.$document.find('.js-galleryfull-prev');
        this.$domFullGallery.next       = this.$document.find('.js-galleryfull-next');
    }

    /**
     * Permet de mettre à jour l'affichage
     * de l'image dans la full gallerie.
     *
     * @param {string} direction  sens de sortie de l'image
     * @return {void}
     */
    updateImageFullGallery(direction) {
        // mettre à jour les fleches de navigation
        this.updateFullGalleryNavigation();

        // faire sortir l'image de l'écran
        this.$domFullGallery.popup.addClass(`is-${direction}-leave`);

        // récupérer les données de l'image
        const image = this.datas[this.currentFullImage];

        // une fois l'image sortie, on affiche la nouvelle image
        setTimeout(() => {
            this.$domFullGallery.popup.removeClass(`is-${direction}-leave`);

            // image
            this.$domFullGallery.image.attr('src', image.src);

            // caption
            this.$domFullGallery.title.text(image.captionTitle);
            this.$domFullGallery.caption.text(image.caption);

            // si légende ou téléchargement
            if (image.download || image.caption || image.captionTitle) {
                this.$domFullGallery.figcaption.removeClass('u-hidden');
            } else {
                this.$domFullGallery.figcaption.addClass('u-hidden');
            }

            // téléchargement de l'image
            if (image.download) {
                this.$domFullGallery.download.attr('href', image.src);
                this.$domFullGallery.download.attr('src', image.download);
                this.$domFullGallery.download.removeClass('u-hidden');
            } else {
                this.$domFullGallery.download.attr('href', '');
                this.$domFullGallery.download.attr('src', '');
                this.$domFullGallery.download.addClass('u-hidden');
            }

            // transition d'entrée de l'image
            this.$domFullGallery.popup.addClass(`is-${direction}-enter`);
            setTimeout(() => {
                this.$domFullGallery.popup.removeClass(`is-${direction}-enter`);
            }, 100);
        }, 350);
    }

    /**
     * Mettre à jour les fléches de navigation dans
     * la full galerie.
     *
     * @return {void}
     */
    updateFullGalleryNavigation() {
        // précédent
        if (this.currentFullImage === 0) {
            this.$domFullGallery.prev.addClass('u-hidden');
        } else {
            this.$domFullGallery.prev.removeClass('u-hidden');
        }

        // suivant
        if (this.currentFullImage === (this.datas.length - 1)) {
            this.$domFullGallery.next.addClass('u-hidden');
        } else {
            this.$domFullGallery.next.removeClass('u-hidden');
        }
    }

    /**
     * Création du contenu html pour
     * la galerie en plein écran.
     *
     * @param {objects} image  objet contenant les informations de l'image
     * @return {void}
     */
    createDomFullGallery(image) {
        // création des éléments
        const $popup      = $('<div class="o-popup js-galleryfull-popup"></div>');
        const $inner      = $('<figure class="o-popup_inner"></figure>');
        const $background = $('<div class="o-popup_background js-galleryfull-close"></div>');
        const $close      = $('<button class="o-popup_close js-galleryfull-close"><svg role="img"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="assets/images/sprite.svg#icon-close"></use></svg></button>');
        const $prev       = $('<button class="o-popup_nav -prev js-galleryfull-prev"><svg role="img"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="assets/images/sprite.svg#icon-arrow-left"></use></svg></button>');
        const $next       = $('<button class="o-popup_nav -next js-galleryfull-next"><svg role="img"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="assets/images/sprite.svg#icon-arrow-right"></use></svg></button>');
        const $image      = $(`<img class="o-popup_image js-galleryfull-image" src="${image.src}"/>`);
        const $title      = $(`<figcaption class="o-popup_caption js-galleryfull-figcaption u-hidden"><p class="js-galleryfull-title">${image.captionTitle}</p><p class="js-galleryfull-caption">${image.caption}</p></figcaption>`);
        const $download   = $(`<a class="o-popup_download js-galleryfull-download u-hidden" href="${image.download}" download="${image.download}"><svg role="img"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="assets/images/sprite.svg#icon-documents"></use></svg></a>`);

        // ajouter les éléments au DOM
        $inner.append($image);
        $inner.append($title);
        $title.append($download);
        $popup.append($inner);
        $popup.append($background);
        $popup.append($close);
        $popup.append($prev);
        $popup.append($next);
        this.$body.append($popup);

        // si téléchargement ou légende, on l'affiche
        if (image.download || image.caption || image.captionTitle) {
            this.$document.find('.js-galleryfull-figcaption').removeClass('u-hidden');
        }

        // le bouton download doit pouvoir être cliqué,
        // si une image est téléchargeable
        if (image.download) {
            this.$document.find('.js-galleryfull-download').removeClass('u-hidden');
        }

        // initialisation des référence DOM pour la FullGallery
        this.initDomFullGallery();

        // ajouter un événement pour la fermeture de la galerie
        this.$document.on('click.Gallery', '.js-galleryfull-close', event => this.onCloseFullGallery(event));

        // ajouter les événements pour la navigation dans la galerie
        this.$document.on('click.Gallery', '.js-galleryfull-prev', event => this.onPrevFullGallery(event));
        this.$document.on('click.Gallery', '.js-galleryfull-next', event => this.onNextFullGallery(event));
    }

    /**
     * Destructeur.
     *
     * @return {void}
     */
    destroy() {
        this.$el.off('.Gallery');
        this.$document.off('.Gallery');

        this.COLUMNS = null;
        this.SLOTS = null;
        this.SLOTS_MAX = null;
        this.GALLERY_IDENT = null;
        this.currentRangeId = 0;
        this.currentFullImage = 0;
        this.$dom = {};
        this.$domFullGallery = {};
    }
}
